// src/store/modules/upload.js
import { uploadFileAPI } from '@/api/upload' // 确保路径正确

const state = {
  isUploading: false,
  uploadError: null,
  uploadResult: null,
  showDownloadButton: false
}

const mutations = {
  SET_UPLOADING(state, status) {
    state.isUploading = status
  },
  SET_UPLOAD_ERROR(state, error) {
    state.uploadError = error
  },
  SET_UPLOAD_RESULT(state, result) {
    state.uploadResult = result
  },
  SET_SHOW_DOWNLOAD_BUTTON(state, status) {
    state.showDownloadButton = status
  },
  RESET_UPLOAD_STATE(state) {
    state.isUploading = false
    state.uploadError = null
    state.uploadResult = null
    state.showDownloadButton = false
  }
}

const actions = {
  async executeFileUpload(
    { commit, dispatch, rootState },
    { fileList, topic, function_type }
  ) {
    commit('SET_UPLOADING', true)
    commit('SET_SHOW_DOWNLOAD_BUTTON', false)
    commit('SET_UPLOAD_ERROR', null)
    commit('SET_UPLOAD_RESULT', null)

    try {
      // 注意：uploadFileAPI 应该返回一个 Promise
      const response = await uploadFileAPI(fileList, topic, function_type)
      commit('SET_UPLOAD_RESULT', response.data) // 假设后端返回的数据在 response.data 中
      commit('SET_SHOW_DOWNLOAD_BUTTON', true)
      await dispatch('user/fetchUserInfo', null, { root: true })
      await dispatch('user/checkLoginStatus', null, { root: true })
      // 如果不是通过付费流程（即 remaining_times > 0 时消耗），则在此处减少次数
      // 更好的做法是在 Home.vue 中调用 user 模块的 action 来减少次数
      // 但根据简单要求，这里暂时不处理次数扣减，让 Home.vue 处理
      // dispatch('user/decrementUserRemainingTimes', null, { root: true });

      return response.data // 返回结果给调用者
    } catch (error) {
      console.error('Upload API error:', error)
      const errorMessage =
        error.response?.data?.message ||
        error.message ||
        '文件上传失败，请稍后再试'
      commit('SET_UPLOAD_ERROR', errorMessage)
      // this._vm.$message.error(errorMessage); // 直接在action中使用this._vm不推荐，错误应由组件处理
      throw error // 抛出错误，让组件捕获
    } finally {
      commit('SET_UPLOADING', false)
    }
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
